import { useCallback, useEffect, useState } from 'react'
import { createContextForController } from 'react-controller-context';

const useProvider = ({
    onRenderField = () => null,
    onRenderFieldEditor = () => null,
    canSave = false,
    busy = false,
    value: defaultValue = '',
    onChange = () => {},
}) => {
    const [ isEditing, setEditing ] = useState(false);
    const [ value, setValue ] = useState(defaultValue);

    //  Update value when new one is provided
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const save = useCallback(async () => {
        try {
            await onChange(value);
            setEditing(false);
        } catch (err) {
            throw err;
        }
    }, [value]);

    const renderField = useCallback(() => onRenderField({value}), [value]);
    const renderFieldEditor = useCallback(() => onRenderFieldEditor({value, setValue}), [value, setValue]);
    const showEditor = useCallback(() => setEditing(true), []);
    const hideEditor = useCallback(() => {
        setEditing(false);
        setValue(defaultValue);
    }, [defaultValue]);
    return {
        save,
        value,
        setValue,
        renderField,
        renderFieldEditor,
        busy,
        canSave,
        showEditor,
        hideEditor,
        isEditing
    };
};

const context = createContextForController(useProvider);
export const Provider = context.Provider;
export const useController = context.useController;
